// extracted by mini-css-extract-plugin
export var banner = "_j0-0";
export var closeButton = "_j0-2";
export var greenCheckmark = "_j0-3";
export var hereLink = "_j0-4";
export var titleIcon = "_j0-1";